/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

function VaultDailyReportNew({ fitCashSummary, otherCashSummary }: any) {
  const nf = Intl.NumberFormat();
  //let denominations = [];

  const {
    denominations,
    openingStock,
    replenishments,
    residuals,
    deposits,
    centralBankCollections,
    vipCollections,
    collections,
    centralBankDeliveries,
    vipDeliveries,
    deliveries,
  } = fitCashSummary;

  let collectionsQtyTotal = 0;
  let collectionsAmtTotal = 0;
  let deliveriesQtyTotals = 0;
  let deliveriesAmtTotals = 0;
  let closingStockQty = 0;
  let closingStockTotal = 0;

  // openingStock.forEach((c:any) => {
  //   const denom = denominations.find(
  //     (dnm:any) => dnm.denomination == c.denomination
  //   );
  //   if (denom == null) {
  //     denominations.push({ denomination: c.denomination });
  //   }
  // });

  const openingStockNotes: any = {};
  let openingStockQty = 0;
  let openingStockTotal = 0;

  openingStock.forEach((note: any) => {
    openingStockNotes[note.denomination] = note.count;
    openingStockQty += note.count;
    openingStockTotal += note.total;
  });

  const replenishmentsNotes: any = {};
  let replensQty = 0;
  let replensTotal = 0;

  replenishments.forEach((note: any) => {
    replenishmentsNotes[note.denomination] = note.count;
    replensQty += note.count;
    replensTotal += note.total;

    deliveriesQtyTotals += note.count;
    deliveriesAmtTotals += note.total;
  });

  const residualsNotes: any = {};
  let residsQty = 0;
  let residsTotal = 0;

  residuals.forEach((note: any) => {
    residualsNotes[note.denomination] = note.count;
    residsQty += note.count;
    residsTotal += note.total;

    collectionsQtyTotal += note.count;
    collectionsAmtTotal += note.total;
  });

  const depositsNotes: any = {};
  let deposQty = 0;
  let deposTotal = 0;

  deposits.forEach((note: any) => {
    depositsNotes[note.denomination] = note.count;
    deposQty += note.count;
    deposTotal += note.total;

    collectionsQtyTotal += note.count;
    collectionsAmtTotal += note.total;
  });

  const collectionsNotes: any = {};
  let collsQty = 0;
  let collsTotal = 0;

  collections.forEach((note: any) => {
    collectionsNotes[note.denomination] = note.count;
    collsQty += note.count;
    collsTotal += note.total;

    collectionsQtyTotal += note.count;
    collectionsAmtTotal += note.total;
  });

  const vipCollectionsNotes: any = {};
  let vipCollsQty = 0;
  let vipCollsTotal = 0;

  vipCollections.forEach((note: any) => {
    vipCollectionsNotes[note.denomination] = note.count;
    vipCollsQty += note.count;
    vipCollsTotal += note.total;

    collectionsQtyTotal += note.count;
    collectionsAmtTotal += note.total;
  });

  const cbCollectionsNotes: any = {};
  let cbCollsQty = 0;
  let cbCollsTotal = 0;

  centralBankCollections.forEach((note: any) => {
    cbCollectionsNotes[note.denomination] = note.count;
    cbCollsQty += note.count;
    cbCollsTotal += note.total;

    collectionsQtyTotal += note.count;
    collectionsAmtTotal += note.total;
  });

  const deliveriesNotes: any = {};
  let delsQty = 0;
  let delsTotal = 0;

  deliveries.forEach((note: any) => {
    deliveriesNotes[note.denomination] = note.count;
    delsQty += note.count;
    delsTotal += note.total;

    deliveriesQtyTotals += note.count;
    deliveriesAmtTotals += note.total;
  });

  const vipDeliveriesNotes: any = {};
  let vipDelsQty = 0;
  let vipDelsTotal = 0;

  vipDeliveries.forEach((note: any) => {
    vipDeliveriesNotes[note.denomination] = note.count;
    vipDelsQty += note.count;
    vipDelsTotal += note.total;

    deliveriesQtyTotals += note.count;
    deliveriesAmtTotals += note.total;
  });

  const cbDeliveriesNotes: any = {};
  let cbDelsQty = 0;
  let cbDelsTotal = 0;

  centralBankDeliveries.forEach((note: any) => {
    cbDeliveriesNotes[note.denomination] = note.count;
    cbDelsQty += note.count;
    cbDelsTotal += note.total;

    deliveriesQtyTotals += note.count;
    deliveriesAmtTotals += note.total;
  });

  closingStockQty =
    openingStockQty +
    residsQty +
    deposQty +
    collsQty +
    vipCollsQty +
    cbCollsQty -
    (replensQty + delsQty + vipDelsQty + cbDelsQty);
  closingStockTotal =
    openingStockTotal +
    residsTotal +
    deposTotal +
    collsTotal +
    vipCollsTotal +
    cbCollsTotal -
    (replensTotal + delsTotal + vipDelsTotal + cbDelsTotal);

  // let unfitDenominations = [];

  // otherCashSummary.forEach((c:any) => {
  //   const denom = unfitDenominations.find(
  //     (dnm:any) => dnm.denomination == c.denomination
  //   );
  //   if (denom == null) {
  //     unfitDenominations.push({ denomination: c.denomination });
  //   }
  // });

  const cutNotes: any = {};
  let cutTotalQty = 0;
  let cutTotalAmt = 0;

  const tapNotes: any = {};
  let tapTotalQty = 0;
  let tapTotalAmt = 0;

  const rejectedNotes: any = {};
  let rejectedTotalQty = 0;
  let rejectedTotalAmt = 0;

  const damagedNotes: any = {};
  let damagedTotalQty = 0;
  let damagedTotalAmt = 0;

  const counterfeitNotes: any = {};
  let counterfeitTotalQty = 0;
  let counterfeitTotalAmt = 0;

  otherCashSummary.forEach((note: any) => {
    cutNotes[note.denomination] = note.cutNotes;
    cutTotalQty += note.cutNotes;
    cutTotalAmt += note.cutTotal;

    tapNotes[note.denomination] = note.tapNotes;
    tapTotalQty += note.tapNotes;
    tapTotalAmt += note.tapTotal;

    rejectedNotes[note.denomination] = note.rejectedNotes;
    rejectedTotalQty += note.rejectedNotes;
    rejectedTotalAmt += note.rejectedTotal;

    damagedNotes[note.denomination] = note.damagedNotes;
    damagedTotalQty += note.damagedNotes;
    damagedTotalAmt += note.damagedTotal;

    counterfeitNotes[note.denomination] = note.counterfeitNotes;
    counterfeitTotalQty += note.counterfeitNotes;
    counterfeitTotalAmt += note.counterfeitTotal;
  });

  return (
    <div className="overflow-auto mt-8">
      <table
        className="table table-responsive mb-4 w-full"
        style={{ tableLayout: "fixed", borderCollapse: "collapse" }}
      >
        <thead>
          <tr>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                textAlign: "left",
                paddingLeft: "2px",
                width: "10%",
              }}
            >
              Description
            </th>

            {denominations.length > 0 && (
              <th
                colSpan={denominations.length}
                style={{
                  border: "0.02rem solid grey",
                  fontSize: "0.9rem",
                  textAlign: "center",
                  paddingLeft: "2px",
                }}
              >
                Denominations Quantities
              </th>
            )}

            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                textAlign: "center",
                paddingLeft: "2px",
                width: "7%",
              }}
            >
              Total Notes
            </th>

            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                textAlign: "center",
                paddingLeft: "2px",
                width: "10%",
              }}
            >
              Total Amount
            </th>
          </tr>

          <tr>
            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                return (
                  <th
                    key={i}
                    style={{
                      border: "0.02rem solid grey",
                      fontSize: "0.7rem",
                      textAlign: "center",
                      paddingLeft: "2px",
                    }}
                  >
                    {dnm.denomination}
                  </th>
                );
              })}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                fontWeight: "bold",
                paddingLeft: "2px",
              }}
            >
              Opening Stock
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.8rem",
                      fontWeight: "bold",
                      paddingLeft: "2px",
                    }}
                  >
                    {openingStockNotes[denom]
                      ? nf.format(openingStockNotes[denom])
                      : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                fontWeight: "bold",
                paddingLeft: "2px",
              }}
            >
              {nf.format(openingStockQty)}
            </td>

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                fontWeight: "bold",
                paddingLeft: "2px",
              }}
            >
              {nf.format(openingStockTotal)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "6px",
              }}
            >
              ATM Residuals
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {residualsNotes[denom]
                      ? nf.format(residualsNotes[denom])
                      : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(residsQty)}
            </td>

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(residsTotal)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "6px",
              }}
            >
              BCDM/CDM Collections
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {depositsNotes[denom] ? nf.format(depositsNotes[denom]) : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(deposQty)}
            </td>
            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(deposTotal)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "6px",
              }}
            >
              Branches Collections
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {collectionsNotes[denom]
                      ? nf.format(collectionsNotes[denom])
                      : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(collsQty)}
            </td>
            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(collsTotal)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "6px",
              }}
            >
              VIP Collections
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {vipCollectionsNotes[denom]
                      ? nf.format(vipCollectionsNotes[denom])
                      : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(vipCollsQty)}
            </td>
            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(vipCollsTotal)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "6px",
              }}
            >
              Central Bank Collections
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {cbCollectionsNotes[denom]
                      ? nf.format(cbCollectionsNotes[denom])
                      : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(cbCollsQty)}
            </td>
            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(cbCollsTotal)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                fontWeight: "bold",
                paddingLeft: "2px",
              }}
            >
              Total Collections
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;

                let resids = 0;

                if (residualsNotes[denom])
                  resids = parseFloat(residualsNotes[denom]);

                let depos = 0;

                if (depositsNotes[denom])
                  depos = parseFloat(depositsNotes[denom]);

                let colls = 0;

                if (collectionsNotes[denom])
                  colls = parseFloat(collectionsNotes[denom]);

                let vipColls = 0;

                if (vipCollectionsNotes[denom])
                  vipColls = parseFloat(vipCollectionsNotes[denom]);

                let cbColls = 0;

                if (cbCollectionsNotes[denom])
                  cbColls = parseFloat(cbCollectionsNotes[denom]);

                const collDenomsQtyTotal =
                  resids + depos + colls + vipColls + cbColls;

                return (
                  <td
                    key={i}
                    style={{
                      border: "0.02rem solid grey",
                      fontSize: "0.8rem",
                      fontWeight: "bold",
                      textAlign: "center",
                      paddingLeft: "2px",
                    }}
                  >
                    {nf.format(collDenomsQtyTotal)}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                fontWeight: "bold",
                paddingLeft: "2px",
              }}
            >
              {nf.format(collectionsQtyTotal)}
            </td>
            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                fontWeight: "bold",
                paddingLeft: "2px",
              }}
            >
              {nf.format(collectionsAmtTotal)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "6px",
              }}
            >
              ATM Replenishment
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {replenishmentsNotes[denom]
                      ? nf.format(replenishmentsNotes[denom])
                      : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(replensQty)}
            </td>
            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(replensTotal)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "6px",
              }}
            >
              Branches Deliveries
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {deliveriesNotes[denom]
                      ? nf.format(deliveriesNotes[denom])
                      : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(delsQty)}
            </td>
            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(delsTotal)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "6px",
              }}
            >
              VIP Deliveries
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {vipDeliveriesNotes[denom]
                      ? nf.format(vipDeliveriesNotes[denom])
                      : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(vipDelsQty)}
            </td>
            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(vipDelsTotal)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "6px",
              }}
            >
              Central Bank Deliveries
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {cbDeliveriesNotes[denom]
                      ? nf.format(cbDeliveriesNotes[denom])
                      : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(cbDelsQty)}
            </td>
            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(cbDelsTotal)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                fontWeight: "bold",
                paddingLeft: "2px",
              }}
            >
              Total Deliveries
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;

                let reps = 0;

                if (replenishmentsNotes[denom])
                  reps = parseFloat(replenishmentsNotes[denom]);

                let dels = 0;

                if (deliveriesNotes[denom])
                  dels = parseFloat(deliveriesNotes[denom]);

                let vipDels = 0;

                if (vipDeliveriesNotes[denom])
                  vipDels = parseFloat(vipDeliveriesNotes[denom]);

                let cbDels = 0;

                if (cbDeliveriesNotes[denom])
                  cbDels = parseFloat(cbDeliveriesNotes[denom]);

                const delDenomsQtyTotal = reps + dels + vipDels + cbDels;

                return (
                  <td
                    key={i}
                    style={{
                      border: "0.02rem solid grey",
                      fontSize: "0.8rem",
                      fontWeight: "bold",
                      textAlign: "center",
                      paddingLeft: "2px",
                    }}
                  >
                    {nf.format(delDenomsQtyTotal)}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                fontWeight: "bold",
                paddingLeft: "2px",
              }}
            >
              {nf.format(deliveriesQtyTotals)}
            </td>
            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid gray",
                fontSize: "0.8rem",
                fontWeight: "bold",
                paddingLeft: "2px",
              }}
            >
              {nf.format(deliveriesAmtTotals)}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td
              style={{
                border: "0.02rem solid gray",
                fontSize: "0.9rem",
                fontWeight: "bold",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Closing Stock
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;

                let opening = 0;
                if (openingStockNotes[denom])
                  opening = parseFloat(openingStockNotes[denom]);

                let reps = 0;

                if (replenishmentsNotes[denom])
                  reps = parseFloat(replenishmentsNotes[denom]);

                let resids = 0;

                if (residualsNotes[denom])
                  resids = parseFloat(residualsNotes[denom]);

                let depos = 0;

                if (depositsNotes[denom])
                  depos = parseFloat(depositsNotes[denom]);

                let colls = 0;

                if (collectionsNotes[denom])
                  colls = parseFloat(collectionsNotes[denom]);

                let vipColls = 0;

                if (vipCollectionsNotes[denom])
                  vipColls = parseFloat(vipCollectionsNotes[denom]);

                let cbColls = 0;

                if (cbCollectionsNotes[denom])
                  cbColls = parseFloat(cbCollectionsNotes[denom]);

                let dels = 0;

                if (deliveriesNotes[denom])
                  dels = parseFloat(deliveriesNotes[denom]);

                let vipDels = 0;

                if (vipDeliveriesNotes[denom])
                  vipDels = parseFloat(vipDeliveriesNotes[denom]);

                let cbDels = 0;

                if (cbDeliveriesNotes[denom])
                  cbDels = parseFloat(cbDeliveriesNotes[denom]);

                const closingQty =
                  opening +
                  resids +
                  depos +
                  colls +
                  vipColls +
                  cbColls -
                  (reps + dels + vipDels + cbDels);

                return (
                  <td
                    key={i}
                    style={{
                      border: "0.02rem solid gray",
                      fontSize: "0.9rem",
                      fontWeight: "bold",
                      textAlign: "center",
                      paddingLeft: "2px",
                    }}
                  >
                    {nf.format(closingQty)}
                  </td>
                );
              })}

            <td
              style={{
                border: "0.02rem solid gray",
                fontSize: "0.9rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              {nf.format(closingStockQty)}
            </td>
            <td
              style={{
                border: "0.02rem solid gray",
                fontSize: "0.9rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              {nf.format(closingStockTotal)}
            </td>
          </tr>
        </tfoot>
      </table>
      <h3 className="font-bold mb-2">Unfit Notes/Coins Details</h3>
      <table className="table table-responsive w-full">
        <thead>
          <tr>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                textAlign: "left",
                paddingLeft: "2px",
                width: "10%",
              }}
            >
              Description
            </th>

            {denominations.length > 0 && (
              <th
                colSpan={denominations.length}
                style={{
                  border: "0.02rem solid grey",
                  fontSize: "0.9rem",
                  textAlign: "center",
                  paddingLeft: "2px",
                }}
              >
                Denominations Quantities
              </th>
            )}

            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                textAlign: "center",
                paddingLeft: "2px",
                width: "7%",
              }}
            >
              Total Notes
            </th>

            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                textAlign: "center",
                paddingLeft: "2px",
                width: "10%",
              }}
            >
              Total Amount
            </th>
          </tr>

          <tr>
            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                return (
                  <th
                    key={i}
                    style={{
                      border: "0.02rem solid grey",
                      fontSize: "0.7rem",
                      textAlign: "center",
                      paddingLeft: "2px",
                    }}
                  >
                    {dnm.denomination}
                  </th>
                );
              })}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "2px",
              }}
            >
              Cut
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {cutNotes[denom] ? nf.format(cutNotes[denom]) : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(cutTotalQty)}
            </td>

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(cutTotalAmt)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "2px",
              }}
            >
              Tap
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {tapNotes[denom] ? nf.format(tapNotes[denom]) : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(tapTotalQty)}
            </td>

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(tapTotalAmt)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "2px",
              }}
            >
              Rejected
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {rejectedNotes[denom] ? nf.format(rejectedNotes[denom]) : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(rejectedTotalQty)}
            </td>
            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(rejectedTotalAmt)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "2px",
              }}
            >
              Damaged
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {damagedNotes[denom] ? nf.format(damagedNotes[denom]) : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(damagedTotalQty)}
            </td>
            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(damagedTotalAmt)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.8rem",
                paddingLeft: "2px",
              }}
            >
              Counterfeit
            </td>

            {denominations.length > 0 &&
              denominations?.map((dnm: any, i: any) => {
                const denom = dnm.denomination;
                return (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      border: "0.02rem solid grey",
                      fontSize: "0.6rem",
                      paddingLeft: "2px",
                    }}
                  >
                    {counterfeitNotes[denom]
                      ? nf.format(counterfeitNotes[denom])
                      : 0}
                  </td>
                );
              })}

            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(counterfeitTotalQty)}
            </td>
            <td
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                paddingLeft: "2px",
              }}
            >
              {nf.format(counterfeitTotalAmt)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default React.memo(VaultDailyReportNew);
